function addItemToCart(variant_id, qty, frequency, unit_type,selling_plan) {
  console.log("terer");
  console.log(selling_plan);
    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": selling_plan
      // "properties": {
      //   "shipping_interval_frequency": frequency,
      //   "shipping_interval_unit_type": unit_type
      // }
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
      }
    });

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    	bubbles: true    // same code for prestige theme   
 	 }));

  }


function buy()
{

  // Get Product selected from popup 1
  product = $('#selectedproduct').text();
  // Get the ID of product mensuel avec engagement
  avec = $("#avec").text();
  // Get all variants names
  options = $('p.price.'+product);
  // initialize class for select the variants ID of the selected product
  classes = '.'+ product;
  // Add the variant names to the selected ID
  for (i = 0; i < options.length; i++) {    
     if (!($("input[name='"+options.eq(i).attr("data-name")+"']:checked").val())){
    $('#'+product+'error').css("display", "block");
      return;
    }
    $('#'+product+'error').css("display", "none");
    classes = classes + '.' + $("input[name='"+options.eq(i).attr("data-name")+"']:checked").val();
    }
  // Get the specific variant
  prodid = Number($(classes).text());
  var selling_plan = $(classes).parent().find(".selling_plan").val();
  console.log(selling_plan);
  console.log(prodid);
  //return false;
  //prodid = 39517997531300 ;
  // Get the Offre ID if exist
  offre = Number($("#offreid").text());

  if (prodid>0){
    if (product == Number(avec)){
      if (offre>0)
      {

	jQuery.post('/cart/add.js', {
        items: [
                  {
                    quantity: 1,
                    id: prodid,
                    selling_plan:selling_plan,
                    "properties": {
                      "shipping_interval_frequency": "1",
                      "shipping_interval_unit_type": "Months"
                      }
                  },
                  {
                    quantity: 1,
                    id: offre
                  }
              	]
    	});
      
      data = 
        {
      "id": prodid,
      "quantity": 1,
      "selling_plan":selling_plan,
      "properties": {
        "shipping_interval_frequency": "1",
        "shipping_interval_unit_type": "Months"
      	}
    	}
      data2 =  {
              "id": offre,
              "quantity": 1
    			}
  		
             
             
       data2 = {
      "id": offre,
      "quantity": 1,
      "properties": {
        "shipping_interval_frequency": "1",
        "shipping_interval_unit_type": "Months"
      }
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
      }
    });
    


  
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    	bubbles: true    // same code for prestige theme   
 	 }));
      setTimeout(function(){ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    	bubbles: true    // same code for prestige theme   
 	 })); }, 900);
      
      
       $('#sabonnermodal').modal('hide')



        carts = $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable')
        var i;
        for (i = 0; i < carts.length; i++) {
          
          if (carts[i].getAttribute("data-drawer-id") == "sidebar-cart") {
                                cart = carts[i];
            cart.click();
                            }
         
        }
    
    }} else {
            

              $('#sabonnermodal').modal('hide')

		addItemToCart(prodid, 1, "1", "Months",selling_plan)
        carts = $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable')
        var i;
        for (i = 0; i < carts.length; i++) {
          
          if (carts[i].getAttribute("data-drawer-id") == "sidebar-cart") {
                                cart = carts[i];
            cart.click();
                            }
         
        }
		 
    }}}


function buy3()
{

  // Get Product selected from popup 1
  product = $('#selectedproduct').text();
  // Get the ID of product mensuel avec engagement
  avec = $("#avec").text();
  // Get all variants names
  options = $('p.price.'+product);
  // initialize class for select the variants ID of the selected product
  classes = '.'+ product;
  // Add the variant names to the selected ID
  for (i = 0; i < options.length; i++) {    
     if (!($("input[name='"+options.eq(i).attr("data-name")+"']:checked").val())){
    $('#'+product+'error').css("display", "block");
      return;
    }
    $('#'+product+'error').css("display", "none");
    classes = classes + '.' + $("input[name='"+options.eq(i).attr("data-name")+"']:checked").val();
    }
  // Get the specific variant
  prodid = Number($(classes).text());
   var selling_plan = $(classes).parent().find(".selling_plan").val();
  //prodid = 39517997531300 ;
  // Get the Offre ID if exist
  offre = Number($("#offreid").text());

  if (prodid>0){
    if (product == Number(avec)){
      if (offre>0)
      {

	jQuery.post('/cart/add.js', {
        items: [
                  {
                    quantity: 1,
                    id: prodid,
                    selling_plan:selling_plan,
                    "properties": {
                      "shipping_interval_frequency": "1",
                      "shipping_interval_unit_type": "Months"
                      }
                  },
                  {
                    quantity: 1,
                    id: offre
                  }
              	]
    	});
      
      data = 
        {
      "id": prodid,
      "quantity": 1,
      "selling_plan":selling_plan,
      "properties": {
        "shipping_interval_frequency": "1",
        "shipping_interval_unit_type": "Months"
      	}
    	}
      data2 =  {
              "id": offre,
              "quantity": 1
    			}
  		
             
             
       data2 = {
      "id": offre,
      "quantity": 1,
      "properties": {
        "shipping_interval_frequency": "1",
        "shipping_interval_unit_type": "Months"
      }
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
      }
    });
    


  
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    	bubbles: true    // same code for prestige theme   
 	 }));
      setTimeout(function(){ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    	bubbles: true    // same code for prestige theme   
 	 })); }, 900);
      
      
       $('#activatemodal').modal('hide')



        carts = $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable')
        var i;
        for (i = 0; i < carts.length; i++) {
          
          if (carts[i].getAttribute("data-drawer-id") == "sidebar-cart") {
                                cart = carts[i];
            cart.click();
                            }
         
        }
    
    }} else {
            

              $('#activatemodal').modal('hide')

		addItemToCart(prodid, 1, "1", "Months",selling_plan)
        carts = $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable')
        var i;
        for (i = 0; i < carts.length; i++) {
          
          if (carts[i].getAttribute("data-drawer-id") == "sidebar-cart") {
                                cart = carts[i];
            cart.click();
                            }
         
        }
		 
    }}}
    

function buy2()
{
  	producttext = $('#selectedproduct2').text();
	product = Number(producttext);
  	aqui = $('#aqui').val();
    message = $('#personnalisez').val();
  	signature = $('#signature').val();
	
 if ((aqui.length>0) && (message.length>0) && (signature.length>0))
 {
     	$('#aqui').css("border-color", "#3e3e3e");
		$('#personnalisez').css("border-color", "#3e3e3e");
		$('#signature').css("border-color", "#3e3e3e");
   		$('#erroroffrir').css("desplay", "none");
		$('#loffrirmodal').modal('hide')
        data = {
          "id": product,
          "quantity": 1,
          properties: {
            For: aqui,
            Message: message,
            Signature: signature
          }
        }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
      }
    });

document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
   carts = $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable')
        var i;
        for (i = 0; i < carts.length; i++) {
          
          if (carts[i].getAttribute("data-drawer-id") == "sidebar-cart") {
                                cart = carts[i];
            cart.click();
                            }
         
        }
 
 
 }
  else {
  //errors here
	$('#erroroffrir').css("display", "block");
    if(aqui.length==0)
    {$('#aqui').css("border-color", "#AA7165");
    }else
      {$('#aqui').css("border-color", "#3e3e3e");
    }
    if(message.length==0)
    {$('#personnalisez').css("border-color", "#AA7165");
    }else{$('#personnalisez').css("border-color", "#3e3e3e");}
    if(signature.length==0)
    {$('#signature').css("border-color", "#AA7165");
    }else{$('#signature').css("border-color", "#3e3e3e");}
  
  }

}



function step1()
{
$("#specialoffre").css("display", "none");
$("#step1").css("display", "block");
//$("#step2").css("display", "none");
$("#back").css("display", "none");
$("#step1title").css("display", "block");
$("#step2title").css("display", "none");
$("#step3title").css("display", "none");
  
n = $("#selectedproduct").text();
$("#"+n).css("display", "none");
}

function step111()
{

$("#step111").css("display", "block");
//$("#step2").css("display", "none");
$("#back").css("display", "none");
$("#step4title").css("display", "block");
$("#step5title").css("display", "none");
    $("#offr2title").css("display", "block");
n = $("#selectedproduct").text();
$("#"+n).css("display", "none");
}




function step2(n,titl)
{ 	
      	$("#back").css("display", "block");
		$("#selectedproduct").text(n);
		sizeoffre = Number($("#offresize").text());

  if ((titl == 'The Monthly Plan')&&(sizeoffre>0)){
        $("#specialoffre").css("display", "block");
    	$("#step1title").css("display", "none");
		$("#step2title").css("display", "none");
		$("#step3title").css("display", "block");

  } else {
      	$("#"+n).css("display", "block");
    	$("#step1title").css("display", "none");
		$("#step2title").css("display", "block");
		$("#step3title").css("display", "none");


		//$("#step2").css("display", "block");
  }
  if (titl == 'avec'){
    $("#selectedproduct").text($("#avec").text());
    $("#step1title").css("display", "none");
    $("#step2title").css("display", "block");
    $("#step3title").css("display", "none");
	$("#"+$("#avec").text()).css("display", "block");
    $("#specialoffre").css("display", "none");

  } else if (titl == 'sans'){
    $("#selectedproduct").text($("#sans").text());
	$("#step1title").css("display", "none");
    $("#step2title").css("display", "block");
    $("#step3title").css("display", "none");
    $("#"+$("#sans").text()).css("display", "block");
    $("#specialoffre").css("display", "none");


  }
	$("#step1").css("display", "none");
}

function step222(n,titl)
{ 	
      	$("#back3").css("display", "block");
		$("#selectedproduct").text(n);
		sizeoffre = Number($("#offresize").text());
  	$("#step4title").css("display", "none");
        $("#offr2title").css("display", "none");
		$("#step5title").css("display", "block");

  if ((titl == 'The Monthly Plan')&&(sizeoffre>0)){
 
    	$("#step4title").css("display", "none");
        $("#offr2title").css("display", "none");
		$("#step5title").css("display", "block");

  } else {
      	$("#"+n).css("display", "block");
    	$("#step4title").css("display", "none");
		$("#step5title").css("display", "block");
		$("#offr2title").css("display", "none");


		//$("#step2").css("display", "block");
  }
  if (titl == 'avec'){
    $("#selectedproduct").text($("#avec").text());
    $("#step4title").css("display", "none");
    $("#step5title").css("display", "block");
    $("#offr2title").css("display", "none");
	$("#"+$("#avec").text()).css("display", "block");

  } else if (titl == 'sans'){
    $("#selectedproduct").text($("#sans").text());
	$("#step4title").css("display", "none");
    $("#step5title").css("display", "block");
    $("#offr2title").css("display", "none");
    $("#"+$("#sans").text()).css("display", "block");


  }
	$("#step111").css("display", "none");
}




function step11()
{ 

	$("#step11").css("display", "block");
  	$("#step22").css("display", "none");
  	$("#back2").css("display", "none");
  	$("#step11title").css("display", "block");
	$("#offrtitle").css("display", "block");
  	$("#offrtitle2").css("display", "none");

}

function step22(n)
{ 	
    $("#back2").css("display", "block");
  	$("#offrtitle").css("display", "none");
  	$("#offrtitle2").css("display", "block");
	$("#step11title").css("display", "none");
	$("#selectedproduct2").text(n);
	$("#step11").css("display", "none");
  	$("#step22").css("display", "block");
  
}

 $(document).ready(function(){
 var sabonner = $("a[href='#sabonner']");
 var loffrir = 	$("a[href='#loffrir']");
 var activate = $("a[href='#activate']");
   
    	sabonner.on("click", function(){
       
        $('#sabonnermodal').modal('show')
        step1()
    	})
        loffrir.on("click", function(){
        $('#loffrirmodal').modal('show')
        step11()
    	})
      	activate.on("click", function(){
       
        $('#activatemodal').modal('show')
        step111();
    	})
 });

